import { Component } from '@angular/core';
import { ButtonBaseComponent } from 'app/shared/components/buttons/button-base.component';

@Component({
    ...ButtonBaseComponent.metaData,
    selector: 'app-button-primary',
    templateUrl: './button-primary.component.html',
    styleUrls: ['./button-primary.component.scss'],
    standalone: false
})
export class ButtonPrimaryComponent extends ButtonBaseComponent {
}
